import React, { useState } from 'react';
import { Input, message } from 'antd';
import { UserOutlined, MobileOutlined, BankOutlined } from '@ant-design/icons';
import './ContactCard.css';

interface ContactCardProps {
    onSubmit?: (data: { name: string; company: string; phone: string; flow_type: number }) => void;
    onSkip?: () => void;
    flow_type?: number;
    isFormShowed?: boolean;
}

const ContactCard: React.FC<ContactCardProps> =
    ({ onSubmit, onSkip, flow_type = 1 }) => {
        const [name, setName] = useState<string>('');
        const [company, setCompany] = useState<string>('');
        const [phone, setPhone] = useState<string>('');
        const [phoneError, setPhoneError] = useState<string>('');
        const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
        const [isFormSkipped, setIsFormSkipped] = useState<boolean>(false);

        const getHeaderText = () => {
            switch (flow_type) {
                case 1:
                    return '我已根据您的要求，生成了适合您的福利方案。如果您需要进一步的方案，请留下您的联系方式，我们将为您设计更加详细的福利方案';
                case 2:
                case 3:
                    return '如您需要专人为您更详细的介绍，可留下您的联系方式，我们将有专业的顾问与您联系';
                default:
                    return '如您需要专人为您更详细的介绍，可留下您的联系方式，我们将有专业的顾问与您联系';

            }
        };

        const validatePhone = (value: string): boolean => {
            const phoneRegex = /^1\d{10}$/;
            if (!value) {
                setPhoneError('');
                return false;
            } else if (!phoneRegex.test(value)) {
                setPhoneError('请输入正确的手机号码');
                return false;
            } else {
                setPhoneError('');
                return true;
            }
        };

        const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value.replace(/[^\d]/g, '');
            setPhone(value);

            // 只有在输入达到11位时才进行验证，让用户可以完成输入过程
            if (value.length === 11) {
                validatePhone(value);
            } else if (phoneError) {
                // 当用户修改有错误的号码时，清除错误信息
                setPhoneError('');
            }
        };

        const handleSubmit = async () => {
            if (!phone) {
                message.error('请填写手机号');
                setPhoneError('请填写手机号');
                return;
            }

            // 验证手机号格式：1开头的11位数字
            if (!validatePhone(phone)) {
                message.error('请输入正确的手机号码');
                return;
            }

            try {
                // 设置表单已提交状态
                setIsFormSubmitted(true);

                if (onSubmit) {
                    onSubmit({ name, company, phone, flow_type });
                }
            } catch (error) {
                console.error('提交用户信息失败:', error);
                message.error('提交失败，请重试');
            }
        };

        const handleSkip = () => {
            setIsFormSkipped(true);
            if (onSkip) {
                onSkip();
            }
        };

        return (
            <div className="message-content contact-card-bubble">
                {/* 提示文案 */}
                <div className="contact-card-header">
                    <p className="contact-card-text">
                        {getHeaderText()}
                    </p>
                </div>

                {/* 表单区域 - 仅当未提交且未跳过时显示 */}
                {!isFormSubmitted && !isFormSkipped && (
                    <div className="contact-form">
                        <div className="form-field">
                            <label className="form-label">姓名</label>
                            <Input
                                placeholder="请输入您的姓名"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                prefix={<UserOutlined className="input-icon-prefix" />}
                                className="contact-input"
                            />
                        </div>

                        <div className="form-field">
                            <label className="form-label">企业名称</label>
                            <Input
                                placeholder="请输入企业名称"
                                value={company}
                                onChange={(e) => setCompany(e.target.value)}
                                prefix={<BankOutlined className="input-icon-prefix" />}
                                className="contact-input"
                            />
                        </div>

                        <div className="form-field">
                            <label className="form-label">
                                手机号 <span className="required-mark">*</span>
                            </label>
                            <Input
                                placeholder="请输入您的手机号"
                                value={phone}
                                onChange={handlePhoneChange}
                                prefix={<MobileOutlined className="input-icon-prefix" />}
                                maxLength={11}
                                className={`contact-input ${phoneError ? 'input-error' : ''}`}
                                status={phoneError ? "error" : ""}
                            />
                            {phoneError && <div className="error-message">{phoneError}</div>}
                        </div>

                        <button
                            onClick={handleSubmit}
                            className="contact-submit-button"
                        >
                            提交
                        </button>

                        <button
                            onClick={handleSkip}
                            className="contact-skip-button"
                        >
                            不需要
                        </button>
                    </div>
                )}
            </div>
        );
    };

export default ContactCard; 